export default __webpack_public_path__ + "static/media/card_1@2x.c78c01db.png";